import { render } from "./BarsIcon.vue?vue&type=template&id=8f3d9b8a&scoped=true"
const script = {}

import "./BarsIcon.vue?vue&type=style&index=0&id=8f3d9b8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f3d9b8a"]])

export default __exports__